// extracted by mini-css-extract-plugin
module.exports = {"loading":"_a1fbf7b","error":"_1e009b2"};